import React from 'react';
import LoaderSvg from './LoaderSvg';
import { Container, Row, Col } from 'reactstrap';
const Loader = () => {
  return (
    <Container>
      <Row>
        <Col className="p-5 d-flex align-items-center justify-content-center loader-wrapper">
          <LoaderSvg />
        </Col>
      </Row>
    </Container>
  );
};

export default Loader;
